enum ResourceType {
  GET_RESOURCES_REQUEST = 'GET_RESOURCES_REQUEST',
  GET_RESOURCES_SUCCESS = 'GET_RESOURCES_SUCCESS',
  GET_RESOURCES_ERROR = 'GET_RESOURCES_ERROR',

  GET_OPEN_GRAPH_SUCCESS = 'GET_OPEN_GRAPH_SUCCESS',
}

export default ResourceType;
